export default "__VITE_ASSET__BXR2sTlp__"